"use strict";
/**
 * @author Maxim Seredkin
 * @param {$RouteProvider} $routeProvider
 * @param {$LocationProvider} $locationProvider
 */
export default [
  "$routeProvider",
  "$locationProvider",
  function ($routeProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $routeProvider
      .when("/", {
        redirectTo: "/welcome",
      })
      .when("/welcome", {
        template: require("../module/welcome/view/welcome.html"),
        controller: "WelcomeController",
        controllerAs: "vm",
      })
      .when("/reference", {
        template: require("../view/index.html"),
        controller: "HomeController",
        controllerAs: "vm",
      })
      .when("/error", {
        template: require("../view/error.html"),
        controller: "ErrorController",
        controllerAs: "vm",
      })
      // region Организации
      .when("/orgs", {
        template: require("../module/org/view/orgs.html"),
        controller: "OrgsController",
        controllerAs: "vm",
      })
      // endregion
      // region Проекты
      .when("/primary-appeals", {
        template: require("../module/appeals/view/index.html"),
        controller: "AppealsController",
        controllerAs: "vm",
      })
      .when("/primary-appeals/edit/:id", {
        template: require("../module/appeals/view/edit.html"),
        controller: "AppealsEditController",
        controllerAs: "vm",
      })
      .when('/primary-appeals/create', {
        template: require('../module/appeals/view/edit.html'),
        controller: 'AppealsEditController',
        controllerAs: 'vm',
      })
      .when('/projects', {
        template: require('../module/project/view/projects.html'),
        controller: 'ProjectsController',
        controllerAs: 'vm',
      })
      .when("/projects/requests/reviewed", {
        template: require("../module/project/module/transaction/view/reviewed-project-transactions.html"),
        controller: "ReviewedProjectRequestsController",
        controllerAs: "vm",
      })
      .when("/projects/requests/rejected", {
        template: require("../module/project/module/transaction/view/rejected-project-transactions.html"),
        controller: "RejectedProjectRequestsController",
        controllerAs: "vm",
      })
      .when("/projects/requests/finalization", {
        template: require("../module/project/module/transaction/view/finalization-project-transactions.html"),
        controller: "FinalizationProjectRequestsController",
        controllerAs: "vm",
      })
      .when("/projects/trash", {
        template: require("../module/project/view/projects-trash.html"),
        controller: "ProjectsTrashController",
        controllerAs: "vm",
      })
      .when("/dashboard", {
        template: require("../module/dashboard/view/dashboard.html"),
        controller: "DashboardController",
        controllerAs: "vm",
      })
      // endregion
      // region Конкретный проект
      .when("/projects/:projectId", {
        template: require("../module/project/view/project.html"),
        controller: "ProjectController",
        controllerAs: "vm",
      })
      // endregion
      // region Сотрудники
      .when("/staffs", {
        template: require("../module/staff/view/staffs.html"),
        controller: "StaffsController",
        controllerAs: "vm",
      })
      // endregion
      // region Земельные участки
      .when("/lands", {
        template: require("../module/land/view/lands.html"),
        controller: "LandsController",
        controllerAs: "vm",
      })
      // endregion
      // region Инвестиционная активность
      .when("/invest-activity", {
        template: require("../module/invest-activity/view/invest-activity.html"),
        controller: "InvestActivityController",
        controllerAs: "vm",
      })
      // endregion
      // region Инвестиционная активность
      .when("/invest-plan", {
        template: require("../module/invest-plan/view/invest-plan.html"),
        controller: "InvestPlanController",
        controllerAs: "vm",
      })
      // endregion
      // region Справочники
      .when("/src-categories", {
        template: require("../module/enchiridion/module/classifier/module/src_category/view/src-categories.html"),
        controller: "SrcCategoriesController",
      })
      .when("/support-tools", {
        template: require("../module/enchiridion/module/handbook/module/support_tool/view/support-tools.html"),
        controller: "SupportToolsController",
        controllerAs: "vm",
      })
      .when("/units", {
        template: require("../module/enchiridion/module/classifier/module/unit/view/units.html"),
        controller: "UnitsController",
        controllerAs: "vm",
      })
      .when("/okveds", {
        template: require("../module/enchiridion/module/classifier/module/okved/view/okveds.html"),
        controller: "OkvedsController",
        controllerAs: "vm",
      })
      .when("/maintenance-kinds", {
        template: require("../module/enchiridion/module/handbook/module/maintenance_kind/view/maintenance-kinds.html"),
        controller: "MaintenanceKindsController",
        controllerAs: "vm",
      })
      .when("/industries", {
        template: require("../module/enchiridion/module/classifier/module/industry/view/industries.html"),
        controller: "IndustriesController",
        controllerAs: "vm",
      })
      .when("/areas", {
        template: require("../module/enchiridion/module/classifier/module/area/view/areas.html"),
        controller: "AreasController",
        controllerAs: "vm",
      })
      .when("/countries", {
        template: require("../module/enchiridion/module/classifier/module/country/view/countries.html"),
        controller: "CountriesController",
        controllerAs: "vm",
      })
      .when("/municipalities", {
        template: require("../module/enchiridion/module/handbook/module/municipality/view/municipalities.html"),
        controller: "MunicipalitiesController",
        controllerAs: "vm",
      })
      .when("/project-statuses", {
        template: require("../module/enchiridion/module/classifier/module/pstatus/view/pstatuses.html"),
        controller: "PStatusesController",
        controllerAs: "vm",
      })
      .when("/investor-countries", {
        template: require("../module/enchiridion/module/classifier/module/investor_country/view/investor-countries.html"),
        controller: "InvestorCountriesController",
        controllerAs: "vm",
      })
      .when("/land-categories", {
        template: require("../module/enchiridion/module/classifier/module/land_category/view/land-categories.html"),
        controller: "LandCategoriesController",
        controllerAs: "vm",
      })
      .when("/phases", {
        template: require("../module/enchiridion/module/handbook/module/phase/view/phases.html"),
        controller: "PhasesController",
        controllerAs: "vm",
      })
      .when("/milestones", {
        template: require("../module/enchiridion/module/handbook/module/milestone/view/milestones.html"),
        controller: "MilestonesController",
        controllerAs: "vm",
      })
      .when("/taxes", {
        template: require("../module/enchiridion/module/handbook/module/tax/view/taxes.html"),
        controller: "TaxesController",
        controllerAs: "vm",
      })
      .when("/ownership-forms", {
        template: require("../module/enchiridion/module/handbook/module/ownership_form/view/ownership-forms.html"),
        controller: "OwnershipFormsController",
        controllerAs: "vm",
      })
      .when("/hazard-classes", {
        template: require("../module/enchiridion/module/handbook/module/hazard_classes/view/hazard-classes.html"),
        controller: "HazardClassesController",
        controllerAs: "vm",
      })
      .when("/support-types", {
        template: require("../module/enchiridion/module/handbook/module/supporttype/view/support-type.html"),
        controller: "SupportTypeController",
        controllerAs: "vm",
      })
      .when("/operation-types", {
        template: require("../module/enchiridion/module/handbook/module/operationtype/view/operation-type.html"),
        controller: "OperationTypeController",
        controllerAs: "vm",
      })
      // endregion
      // region Пользователи
      .when("/users", {
        template: require("../module/user/view/users.html"),
        controller: "UsersController",
        controllerAs: "vm",
      })
      .when("/users/account", {
        template: require("../module/user/view/account.html"),
        controller: "AccountController",
        controllerAs: "vm",
      })
      // endregion
      // region Аудит
      .when("/audits", {
        template: require("../module/audit/view/audits.html"),
        controller: "AuditsController",
        controllerAs: "vm",
      })
      // endregion
      // region Отчеты
      // Отчет "События по проекту".
      .when("/reports/project-chronology", {
        template: require("../module/reports/module/project_chronology/view/project-chronology.html"),
        controller: "ProjectChronologyController",
        controllerAs: "vm",
      })
      // endregion
      // region Меры поддержки
      .when("/support-measures", {
        template: require("../module/support/view/supports.html"),
        controller: "SupportsController",
        controllerAs: "vm",
      })
      // endregion
      // region Сертификаты ЭЦП
      .when("/sign", {
        template: require("../module/sign/view/sign.html"),
        controller: "SignController",
        controllerAs: "vm",
      })
      // endregion
      // region Проекты ГЧП
      .when('/project-gchp', {
        template: require('../module/project-gchp/view/project-gchp.html'),
        controller: 'ProjectGchpController',
        controllerAs: 'vm',
      })
      // endregion
      .otherwise({ redirectTo: '/welcome' });
  },
];
